export default __webpack_public_path__ + "static/media/disclaimer.83e77a96.svg";